import { render, staticRenderFns } from "./AssignmentStatusLabel.vue?vue&type=template&id=21575326&scoped=true"
import script from "./AssignmentStatusLabel.vue?vue&type=script&lang=js"
export * from "./AssignmentStatusLabel.vue?vue&type=script&lang=js"
import style0 from "./AssignmentStatusLabel.vue?vue&type=style&index=0&id=21575326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21575326",
  null
  
)

export default component.exports